import { Component } from '@angular/core';

@Component({
  selector: 'my-usuario',
  styles: [],
  templateUrl: 'usuario.component.html'
})

export class usuarioComponent {}



// WEBPACK FOOTER //
// ./src/app/usuario/usuario.component.ts